module.exports = __webpack_public_path__ + "assets/img/ewm-xcx.9f39f0ac.png";